<template>
    <div class="introduction">
     <!-- <header>
        <p class="operation">
            <span class="el-icon-view"></span>
            <span>{{ statistics ? statistics.viewcount : '' }}</span>
            <span class="el-icon-download"></span>
            <span>{{ statistics ? statistics.downloadcount : '' }}</span>
            <span class="el-icon-star-off"></span>
            <span>{{ statistics ? countStarts(statistics.score) : '' }}</span>
        </p>
     </header> -->
     <main>
       <div class="title">资源介绍</div>
       <ul class="list">
           <li ref="descRef" class="item" data-after="">
               <div class="label">资源简介 :</div>
               <el-tooltip :content="resDesc" placement="top" effect="light">
                <div ref="descTextRef" class="content">{{ resDesc }}</div>
               </el-tooltip>
           </li>
            <!-- <li class="item">
               <div class="label">媒体类型 :</div>  
               <div class="content">{{ resInfo.extension }}</div>
           </li> -->
            <!-- <li class="item">
               <div class="label">资源来源 :</div>
               <div class="content">{{ resInfo.source === 'IFLYTEK' ? '畅言教育' : resInfo.source }}</div>
           </li> -->
            <li class="item">
               <div class="label">上传者 :</div>    
               <div class="content">{{ resInfo.creator }}</div>
           </li>
            <li class="item">
               <div class="label">资源大小 :</div> 
               <div class="content">{{ resInfo.size }}</div>   
           </li>
            <li class="item">
               <div class="label">上传时间 :</div> 
               <div class="content">{{ resInfo.uploadtime }}</div>
           </li>
            <li class="item">
               <div class="label">资源评价 :</div>
               <div class="content">
                 <el-rate
                  v-model="rateValue"
                  disabled
                  text-color="#ff9900"
                  score-template="{value}">
                </el-rate>
                 <span>( {{ statistics ? statistics.scorecount : '' }}人评价 )</span> 
              </div>
           </li>
       </ul>
     </main>
    </div>
</template>

<script>
import eventBus from '@/utils/event-bus'
export default {
  name: 'Introduction',
  components: {
  },
  data () {
    return {

    }
  },
  mounted() {
    eventBus.$on('download-count', value => {
      this.statistics.downloadcount = value
    })
  },
  updated() {
    // descTextRef DOM更新后会调用此方法
    this.setEllipsis()
  },
  props: {
    resInfo: {
      type: Object,
      default: () => ({})
    },
  },
  computed: {
    statistics() {
      return this.resInfo
    },
    rateValue(){
      let score = 0
      if(this.resInfo._score) {
        this.resInfo._score.forEach(item => {
          if(item === 'full_star') score++
          if(item === 'half_star') score += 0.5
        })
      }
      return score
    },
    resDesc() {
      if(this.resInfo.extension === 'zip')
        return `本资源为《${this.resInfo.title}》的资源包, 包含本课的教学设计、课件、习题、素材等类型的推荐资源。`
      return this.resInfo.description ? this.resInfo.description : '暂无简介'
    }
  },
  methods: {
       countStarts($score = 0) {
         if($score>100){
            $score=100;
        }
        let $s = $score / 20;
        if(parseInt($s) !== parseFloat($s)) {
           $s = $s.toFixed(1);
        }
        return $s;
    },
    getStyle(element, attr) {
      return window.getComputedStyle(element, false)[attr]
    },
    setEllipsis() {
      let descHeight = this.getStyle(this.$refs['descTextRef'], 'height')
      let descNum = parseInt(descHeight) // 80.12px可以解析成整数80
      if(descNum > 80) {
        this.$refs['descRef'].setAttribute('data-after', '...')
      }
    }
  },
}
</script>

<style scoped lang="less">
  .introduction {
    height: 100%;
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    header {
      height: 35px;
      .operation {
        float: right;
        font-size: 14px;
        color: #7C7C7C;
        span:nth-child(even) {
            margin-right: 10px;
        }
      }
    }
    main {
      border: 1px solid #F0F0F0;
      background-color: #FAFAFA;
      padding: 5px;
      flex: 1;
      overflow: auto;
      .title {
          color: #368FFF;
          height: 30px;
      }
      .list {
          height: calc(100% - 40px);
          display: flex;
          flex-direction: column;
          .item {
              border-top: 1px dashed #D9D9D9;
              font-size: 14px;
            //   line-height: 34px;
              flex: 1;
              .label {
                float: left;
                width: 30%;
                // height: 100%;
                line-height: 4.2;
                color: #262626;
                font-weight: 560;
              }
              .content {
                float: right;
                width: 70%;
                // height: 100%;
                line-height: 4.2;
                color: #7C7C7C;
                .el-rate {
                  line-height: inherit;
                }
              }
              &:first-child {
                flex: 0 0 80px;
                overflow: hidden;
                position: relative;
                &::after {
                  content: attr(data-after);
                  position: absolute;
                  right: 0;
                  bottom: 0;
                  width: 10px;
                  margin-bottom: 7px;
                  background-color: #FAFAFA;
                  color: #7C7C7C;
                }
                .label {
                   line-height: 1.8;
                }
                .content {
                  line-height: 1.8;
                  word-break: break-all;
                }
              }
              &:last-child {
                .content {
                  display: inline-flex;
                }
              }
          }
      }
    }
  }
</style>
